module.exports = __webpack_public_path__ + "static/media/paintpro.684687d7.png";